<template>
  <div class="wrap-dept">
    <!-- 科室分类 -->
    <div class="container" :class="searchVisible ? 'bg2' : ''">
      <div class="close-icon" @click="closeHandle">
        <span class="el-icon-close"></span>
      </div>
      <!-- 左侧科室菜单 -->
      <div class="dept-left">
        <div class="title">
          <img src="/images/preloader/icon-dept.png" alt="" />
          <span>找科室</span>
        </div>
        <div ref="menuList" class="list-wrap">
          <ul class="list">
            <li
              v-for="(item, index) in deptList"
              :key="index"
              :class="
                curSelectDeptIndex === index && searchKey.length === 0
                  ? 'active'
                  : ''
              "
              @click="selectDept(index)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="btn-group">
          <div @click="scrollHandle('up')">
            <img src="/images/preloader/icon-up.png" alt="" /><span>上翻</span>
          </div>
          <div @click="scrollHandle('down')">
            <img src="/images/preloader/icon-down.png" alt="" /><span
              >下翻</span
            >
          </div>
        </div>
      </div>

      <!-- 中间科室选项 -->
      <div class="dept-middle">
        <!-- <div class="dept-video" @click="playVideo">
          <video class="protect-video" :src="qiniuBaseUrl + 'Fk7vbuW9VhwrLx365Gb7c8NSFFrt'"></video>
          <i class="el-icon-caret-right"></i>
        </div> -->
        <div class="btn-group-top">
          <div @click="searchSwitch">
            <img src="/images/preloader/icon_foot_search.png" alt="" /><span
              >拼音查找</span
            >
          </div>
        </div>
        <div class="content">
          <ul v-if="pinyinSearchList.length > 0" class="list">
            <li
              v-for="(item, index) in pinyinSearchList"
              :key="index"
              @click="selectDeptItem(item.localPoint, item.ormName)"
            >
              {{ item.ormName }}
            </li>
          </ul>
          <noContent v-else-if="searchKey.length > 0"></noContent>

          <ul v-else-if="deptList2.length > 0" class="list">
            <li
              v-for="(item, index) in deptList2"
              :key="index"
              @click="selectDeptItem(item.localPoint, item.ormName)"
            >
              {{ item.ormName }}
            </li>
          </ul>

          <noContent v-else></noContent>
        </div>

        <div class="btn-group">
          <div @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
        </div>
      </div>

      <!-- 右侧拼音查找 -->
      <div v-show="searchVisible" class="dept-right">
        <div class="title">拼音查找</div>
        <input
          v-model="searchKey"
          class="search-input"
          @input="enterSaver"
          disabled
          type="text"
        />
        <div class="letter-wrap">
          <div
            v-for="(item, index) in letterArr"
            :key="index"
            class="letter"
            @click="inputLetter(item)"
          >
            {{ item }}
          </div>
          <div class="letter" style="flex:1;" @click="deleteLetter">
            <img src="/images/preloader/icon_pingyin_deletion.png" alt="" />
            <span>回删</span>
          </div>
        </div>
        <div class="btn-group">
          <div @click="searchSwitch">
            <img src="/images/preloader/icon_foot_packup.png" alt="" /><span
              >收起</span
            >
          </div>
          <div class="close-btn" @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="dialogVisible" class="video-play" :visible.sync="dialogVisible">
      <video
        ref="video"
        class="look-video"
        controls
        autoplay
        :src="qiniuBaseUrl + 'Fk7vbuW9VhwrLx365Gb7c8NSFFrt'"
      ></video>
      <div class="tips" @click="closeVideo">
        点击进入使用导航 &nbsp;<i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import noContent from "@/components/no-content";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    noContent
  },
  props: {},
  data() {
    return {
      dialogVisible: false,
      searchVisible: false, // 拼音搜索显示状态
      searchKey: "", // 拼音搜索关键字
      pinyinSearchList: [], // 拼音搜索结果
      deptList: [], // 科室分类列表
      deptList2: [], // 科室分类列表
      curSelectDeptIndex: 0 // 当前选择科室分类下标
    };
  },
  computed: {
    // 七牛图片地址
    qiniuBaseUrl() {
      return this.$store.state.app.qiniuBaseUrl;
    },
    // 建筑信息
    buildInfo: {
      get() {
        return this.$store.state.nav.buildInfo;
      },
      set(val) {
        this.$store.commit("nav/set_buildInfo", val);
      }
    },
    // 科室分类子项
    curDeptChilds() {
      if (this.deptList[this.curSelectDeptIndex]) {
        return this.deptList[this.curSelectDeptIndex].detailDTOList;
      } else {
        return [];
      }
    },
    // 功能模块
    FUN_MODULE() {
      return this.$store.state.app.FUN_MODULE;
    },
    ...mapState("app", ["letterArr"])
  },
  watch: {
    searchKey(val) {
      if (val.length > 0) {
        this.pinyinSearch(val);
      } else {
        this.pinyinSearchList = [];
      }
    }
  },
  async created() {
    let deptRes = await this.getDeptList();
    console.log(deptRes);
    this.deptList = deptRes;
    // 初始选择第一个一级科室
    if (this.deptList.length > 0) {
      this.selectDept(0);
    }
  },
  mounted() {},
  methods: {
    ...mapActions("nav", [
      // 调用定时器
      "enterSaver"
    ]),
    playVideo() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.video.addEventListener("ended", e => {
          console.log("ended 播放完成");
          setTimeout(() => {
            this.dialogVisible = false;
          }, 1000);
        });
      });
    },
    closeVideo() {
      this.dialogVisible = false;
    },
    // 选择一级科室
    async selectDept(index) {
      this.searchKey = "";
      this.curSelectDeptIndex = index;
      let deptRes2 = await this.getDeptList2(this.deptList[index]["deptId"]);
      this.deptList2 = deptRes2;
    },
    // 选择科室
    selectDeptItem(poiId, name) {
      this.$emit("selectPoi", poiId, name, this.FUN_MODULE.DEPT);
      this.$emit("close");
    },
    // 上翻下翻
    scrollHandle(type) {
      console.log(this.$refs.menuList.scrollTop);
      let scrollTop = this.$refs.menuList.scrollTop;
      if (type === "up") {
        this.$refs.menuList.scrollTop = scrollTop - 600;
      } else {
        this.$refs.menuList.scrollTop = scrollTop + 600;
      }
    },
    // 拼音搜索开关
    searchSwitch() {
      this.searchVisible = !this.searchVisible;
    },
    // 输入字母
    inputLetter(letter) {
      this.searchKey += letter;
    },
    // 删除字母
    deleteLetter() {
      if (this.searchKey.length > 0) {
        console.log(123123);
        this.searchKey = this.searchKey.substr(0, this.searchKey.length - 1);
      }
    },
    // 关闭科室窗口
    closeHandle() {
      this.$emit("close");
    },
    // 获取科室列表（1级）
    async getDeptList(buildId = this.buildInfo.buildId) {
      try {
        let res = await this.$apis.nav.queryDeptList({
          buildId: buildId
        });
        let data = JSON.parse(res.data);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    // 获取科室列表（2级）
    async getDeptList2(
      parentId = null,
      search = null,
      buildId = this.buildInfo.buildId
    ) {
      try {
        let res = await this.$apis.nav.queryDeptList2({
          buildId,
          parentId,
          search
        });
        let data = JSON.parse(res.data);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    // 拼音搜索
    async pinyinSearch(search, buildId = this.buildInfo.buildId) {
      let res = await this.getDeptList2(null, search, buildId);
      this.pinyinSearchList = res;
    }
  }
};
</script>

<style scoped lang="scss">
.wrap-dept {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: $color-opacity-regular;
  //科室列表
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 100%;
    transform: translate(-50%, -50%);
    background: url("/images/preloader/bg-symptom1.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    padding: 5px 10px 12px 8px;
    box-sizing: border-box;
    .close-icon {
      display: none;
    }
  }
  .bg2 {
    background: url("/images/preloader/bg-symptom2.png") no-repeat;
    background-size: 100% 100%;
  }
  .dept-left {
    width: 295px;
    color: $color-white;
    .title {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      img {
        margin: 0 10px 0 0;
        width: 32px;
      }
    }
    .list-wrap {
      height: calc(100% - 220px);
      overflow: auto;
      .list {
        list-style: none;
      }
      li {
        font-size: 26px;
        height: 70px;
        line-height: 70px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .active {
        background: #386998;
        color: #40e9ad;
        border-left: 5px solid #40e9ad;
      }
    }
    .btn-group {
      flex: 0 0 wrap;
      display: flex;
      height: 100px;
      align-items: center;
      justify-content: space-evenly;
      & > div {
        width: 100px;
        height: 40px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        border-radius: 50px;
        // margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 10px 0 0;
        width: 24px;
      }
    }
  }
  .dept-middle {
    width: 1160px;
    padding: 40px 0 40px 0;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .dept-video {
      display: flex;
      position: relative;
      margin-left: 20px;
      margin-bottom: 20px;
      width: 110px;
      .protect-video {
        width: 110px;
      }
      .el-icon-caret-right {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        border-radius: 50%;
        cursor: pointer;
      }
    }
    .content {
      height: 100%;
    }
    .list {
      color: $color-white;
      font-size: 28px;
      width: 100%;
      height: 100%;
      overflow: auto;
      text-align: left;
      padding-bottom: 100px;
    }
    li {
      display: inline-block;
      height: 80px;
      line-height: 80px;
      box-sizing: border-box;
      padding: 0 40px;
      margin: 0 16px 20px;
      background: linear-gradient(#1cb4fb, #048ae8);
      border-radius: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .btn-group {
      position: relative;
      display: flex;
      flex-direction: row-reverse;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
    .btn-group-top {
      position: relative;
      display: flex;
      padding-bottom: 40px;
      margin-left: 16px;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
  }
  .dept-right {
    position: relative;
    width: 385px;
    margin: 40px 0 40px 0;
    border-left: 1px solid #618aaf;
    .title {
      font-size: 28px;
      color: $color-white;
      width: 306px;
      margin: 0 auto 40px;
      text-align: left;
    }
    .search-input {
      border: 1px solid #618aaf;
      border-radius: 10px;
      width: 306px;
      height: 50px;
      line-height: 50px;
      margin: 0 auto;
      text-align: left;
      color: $color-white;
      font-size: 26px;
      padding: 0 20px;
      box-sizing: border-box;
      background: transparent;
    }
    .letter-wrap {
      display: flex;
      flex-wrap: wrap;
      border: 1px solid #618aaf;
      border-radius: 10px;
      overflow: hidden;
      width: 306px;
      margin: 10px auto 0;
      .letter {
        width: 50px;
        height: 50px;
        line-height: 50px;
        border: 1px solid #618aaf;
        // box-sizing: border-box;
        margin: -1px 0 0 -1px;
        color: $color-white;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          background: #345b85;
        }
        img {
          margin: 0 10px 0 0;
        }
      }
    }
    .btn-group {
      display: flex;
      flex-direction: row-reverse;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      justify-content: center;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        color: $color-white;
      }
      .close-btn {
        display: none;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
  }
  .video-play {
    position: absolute;
    z-index: 1000;
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tips {
    position: fixed;
    width: 368px;
    height: 80px;
    z-index: 99999;
    font-size: 32px;
    font-weight: 500;
    color: #ffffff;
    line-height: 45px;
    background: rgba(0, 0, 0, 0.6);
    top: 26px;
    right: 40px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dept-detail-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: $color-opacity-primary;
    z-index: 999999;
  }
  .dept-detail {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1472px;
    height: 819px;
    transform: translate(-50%, -50%);
    background: url("/images/preloader/bg-symptom.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    padding: 45px 50px 52px 48px;
    box-sizing: border-box;
    flex-direction: column;
    text-align: left;
    color: $color-white;
    .title {
      font-size: 36px;
      margin: 0 0 20px 0;
      height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content {
      height: 600px;
      width: 100%;
      font-size: 24px;
      text-indent: 2em;
    }
    .description {
      height: 100%;
      overflow: auto;
      line-height: 50px;
      font-size: 24px;
    }
    .btn-group {
      position: relative;
      display: flex;
      flex-direction: row-reverse;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        color: $color-white;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
      .guahao {
        position: absolute;
        left: 0;
        top: 0;
        background: linear-gradient(to bottom, #40e9ad 0%, #03af6c 100%);
      }
    }
  }
}

.deptPop {
  height: 660px;
  padding: 20px 0;
  box-sizing: border-box;
  .content {
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  .dept-wrap {
    margin: 0 0 20px 0;
    .dept-cate {
      font-size: 36px;
      color: #fff;
      text-align: left;
      margin: 0 0 20px 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .dept-list {
      display: flex;
      flex-wrap: wrap;
      color: $color-white;
      font-size: 28px;
      // flex: 1;
      align-content: flex-start;
      height: 100%;
      width: 100%;
      overflow: auto;
    }
    .dept-li {
      width: 258px;
      height: 98px;
      line-height: 80px;
      box-sizing: border-box;
      padding: 5px 20px 10px 18px;
      margin: 0 17.5px 20px;
      text-align: center;
      background: url("/images/preloader/btn-bg1.png");
      background-size: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
@media (orientation: portrait) {
  .wrap-dept {
    .container {
      height: 68vh;
      padding: 0;
      // background-size: auto 100%;
      background: rgba(46, 90, 141, 0.94);
      border-radius: 20px;
      .close-icon {
        display: block;
        position: absolute;
        top: -60px;
        right: 0;
        font-size: 38px;
        color: #ccc;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border-radius: 50%;
        border: 2px solid #ccc;
        padding: 0;
        font-weight: bold;
        box-sizing: border-box;
      }
    }
    .dept-middle {
      background: #476f9b;
      border-radius: 0 20px 20px 0;
      .content {
        height: calc(100% - 620px);
      }
      .list {
        height: calc(100% - 620px);
        padding: 0;
      }
      .btn-group {
        display: none;
      }
      .btn-group-top {
        display: none;
      }
    }
    .dept-left {
      .btn-group {
        & > div {
          width: 120px;
          height: 50px;
          font-size: 20px;
        }
      }
    }
    .dept-right {
      position: absolute;
      margin: 0;
      height: 600px;
      width: 1160px;
      bottom: 0;
      right: 0;
      display: block !important;
      border: 0;
      .title {
        text-align: center;
        margin: 0 auto 10px;
      }
      .search-input {
        width: 936px;
        height: 70px;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .letter-wrap {
        width: 936px;
        .letter {
          width: 70px;
          height: 70px;
          font-size: 30px;
          img {
            width: 20px;
          }
        }
      }
      .btn-group {
        position: absolute;
        right: 30px;
        left: auto;
        bottom: 40px;
        width: 200px;
        div:nth-of-type(1) {
          display: none;
        }
        .close-btn {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
